import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Ideas shouldn't wait for engineers.",
    body: "Every day a brilliant app dies in a notes app. ArcaCentum collapses the distance between a thought and a shipped product to almost nothing.",
  },
  {
    n: "02",
    title: "The interface is a conversation.",
    body: "No components to drag, no configs to memorize. You describe intent in your own words and watch a native app assemble itself around it.",
  },
  {
    n: "03",
    title: "Real apps. Real stores. Real revenue.",
    body: "Not prototypes. Not toys. Production-grade iOS and Android builds with analytics and monetization wired in from the first tap.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-28 md:py-40 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-mono text-xs uppercase tracking-[0.25em] text-[#00F0FF] mb-20"
        >
          / manifesto
        </motion.p>

        <div className="space-y-24">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className={`grid md:grid-cols-12 gap-8 items-start ${i % 2 === 1 ? "md:pl-32" : ""}`}
            >
              <div className="md:col-span-3">
                <span className="font-editorial text-7xl md:text-8xl text-[#0055FF] leading-none">{c.n}</span>
              </div>
              <div className="md:col-span-9">
                <h3 className="font-editorial text-4xl md:text-6xl leading-[1.05] mb-6 text-white">{c.title}</h3>
                <p className="text-slate-400 text-lg max-w-2xl leading-relaxed">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
